<template>
    <breadcrumb class="bg-light p-0" :items="breadcrumbs" />
</template>

<script type="text/javascript">
import TEMPLATES from "@/constants/templates";
import { find } from "lodash";
import Breadcrumb from "@/components/commons/breadcrumb.vue";

export default {
    components: {
        Breadcrumb
    },
    props: {
        title: {
            type: String,
            default: null
        }
    },
    computed: {
        breadcrumbs() {
            let templateType = find(TEMPLATES.LIST, {
                route: String(this.$route.params.type)
            });

            let routes = [
                {
                    text: "Settings",
                    href: process.env.APPS + "business/business"
                },
                {
                    text: `List of ${templateType.label} Templates`,
                    to: {
                        name: "template_list",
                        params: {
                            type: templateType.route
                        }
                    }
                }
            ];

            if (this.$route.name == "template_details") {
                routes.push({
                    text: `${this.title}`,
                    active: true
                });
            }
            return routes;
        }
    }
};
</script>
